import api, { ApiResponse } from './api';

import {
  MonitoringSystemUser,
  SharedMonitoringPlants,
  CreateMonitoringSystemUserProps,
  UpdateMonitoringSystemUserProps,
  DeleteMonitoringSystemUserProps,
} from 'entities/MonitoringSystemUser';

interface CreateMonitorSystemUserResponse {
  success: boolean;
  data: MonitoringSystemUser;
}

export const createMonitoringSystemUserService = (
  data: CreateMonitoringSystemUserProps
): ApiResponse<CreateMonitorSystemUserResponse> => {
  const signInData = encodeURIComponent(JSON.stringify(data.signInData));

  return api({
    method: 'post',
    url: 'monitoring-system-user',
    data: {
      monitoringSystemId: data.monitoringSystemId,
      identifier: data.identifier,
      signInData,
    },
    useToken: true,
  });
};

interface GetMonitoringSystemUserListResponse {
  success: boolean;
  data: MonitoringSystemUser[];
}

export const getMonitoringSystemUserListService =
  (): ApiResponse<GetMonitoringSystemUserListResponse> =>
    api({
      method: 'get',
      url: 'monitoring-system-user',
      useToken: true,
    });

interface GetSharedMonitoringPlantsResponse {
  success: boolean;
  data: SharedMonitoringPlants[];
}

export const getSharedMonitoringPlantsService =
  (): ApiResponse<GetSharedMonitoringPlantsResponse> =>
    api({
      method: 'get',
      url: 'monitoring-system-user/shared-plants',
      useToken: true,
    });

interface UpdateMonitoringSystemUserResponse {
  success: boolean;
  data: MonitoringSystemUser;
}

export const updateMonitoringSystemUserService = (
  data: UpdateMonitoringSystemUserProps
): ApiResponse<UpdateMonitoringSystemUserResponse> => {
  const signInData = encodeURIComponent(JSON.stringify(data.signInData));

  return api({
    method: 'patch',
    url: `monitoring-system-user/${data.monitoringSystemUserId}`,
    data: {
      identifier: data.identifier,
      signInData,
    },
    useToken: true,
  });
};

interface DeleteMonitoringSystemUserResponse {
  success: boolean;
  data: MonitoringSystemUser;
}

export const deleteMonitoringSystemUserService = (
  data: DeleteMonitoringSystemUserProps
): ApiResponse<DeleteMonitoringSystemUserResponse> =>
  api({
    method: 'delete',
    url: `monitoring-system-user/${data.monitoringSystemUserId}`,
    useToken: true,
  });
